import { useQuery } from "@tanstack/react-query";
import { getRefundApplications, RefundApplication } from "@/http/refundApplicationsApi";
import { getRefundApplicationsQueryKey } from "@/utils/queryKeys";
import { useAuth } from "@/contexts/AuthContext";
import { useClub } from "@/contexts/ClubContext";

export const useGetRefundApplicationsQuery = (params?: {
  page?: number;
  pageSize?: number;
  enabled?: boolean;
}) => {
  const { authPhone } = useAuth();
  const { selectedClubId } = useClub();
  const { page = 1, pageSize = 20, enabled = true } = params || {};

  return useQuery<RefundApplication[]>({
    queryKey: [
      ...getRefundApplicationsQueryKey(),
      { page, pageSize, phone: authPhone, clubId: selectedClubId },
    ],
    queryFn: async () => {
      const response = await getRefundApplications(authPhone, {
        page,
        pageSize,
        clubId: selectedClubId,
      });
      return response.data.data;
    },
    enabled: enabled && !!authPhone && !!selectedClubId,
  });
};
